// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { headerLinkListStyles } from "@sc/Overrides/Widgets/Header/HeaderLinkList";
import ArrowDown from "@sc/XDL/Icons/ArrowDown";
import { color, styledScrollbar } from "@sc/XDL/Utilities";
import { css } from "styled-components";

headerLinkListStyles.headerLinkListWrapper = {
    css: css`
        padding: 0;
        display: flex;
    `,
};

headerLinkListStyles.link = {
    typographyProps: {
        size: 14,
        weight: "bold",
        lineHeight: "22px",
        css: css`
            margin-right: 16px;
            display: inline-block;
            &&& {
                color: ${getColor("text.main")};
            }
        `,
    },
};

headerLinkListStyles.menuLink = {
    color: "text",
    icon: {
        iconProps: {
            src: ArrowDown,
            size: 13,
            css: css`
                width: 9px;
                margin: 0;
            `,
        },
        position: "right",
    },
    typographyProps: {
        size: 14,
        weight: "bold",
        css: css`
            &&& {
                line-height: 22px;
            }
        `,
    },
    css: css`
        transition: all ease-in-out 300ms;
        display: flex;
        align-items: center;
        gap: 8px;
        &[aria-expanded="true"] {
            ${IconWrapper} {
                rotate: 180deg;
            }
        }
    `,
};

headerLinkListStyles.menuContent = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        color: ${color("text.main")};
        padding: 16px;
        max-height: 50vh;
        overflow: auto;
        ${styledScrollbar()}
    `,
};
